<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path d="M7.5,7.5L6,9C5.17,9.83,3.83,9.83,3,9S2.17,6.83,3,6l1.5-1.5L3,3L1.5,4.5c-1.66,1.66-1.66,4.34,0,6s4.34,1.66,6,0L9,9L7.5,7.5z" />
	<polygon points="4,2 5.5,0.5 7,2 5.5,3.5" />
	<polygon points="8.5,6.5 10,5 11.5,6.5 10,8" />
	<polygon points="12,0 8.29,1.21 9.29,3.21 7,4 7,5 10.71,3.79 9.71,1.79 12,1" />
</svg>
</template>